import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import StageAppResource from './StageAppResource';
import StageRoleAppResource from './StageRoleAppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';

class StageWorkspaceMemberAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Stage-Workspace-Member';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'stages/workspaces/members';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'stageUuid',
            'workspaceOrganizationMemberUuid',
            'stageRoleUuid',
            'stage',
            'stageRole',
            'workspaceOrganizationMember',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            stage: StageAppResource,
            stageRole: StageRoleAppResource,
            workspaceOrganizationMember: WorkspaceOrganizationMemberAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            stage: 'stage_uuid',
            stageRole: 'stage_role_uuid',
            workspaceOrganizationMember: 'workspace_organization_member_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            stageUuid: {
                type: 'string',
                presence: true,
            },
            workspaceOrganizationMemberUuid: {
                type: 'string',
                presence: true,
            },
            stageRoleUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default StageWorkspaceMemberAppResource;
